import { Injectable } from '@angular/core';
import { filterNilValue, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Event } from './event.model';
import { EventState, EventStore } from './event.store';

@Injectable()
export class EventQuery extends QueryEntity<EventState> {
  active$ = (this.selectActive() as Observable<Event>).pipe(filterNilValue());
  userEvents$ = this.selectAll().pipe(
    map((events) => events.filter((event) => event.joined))
  );
  userEventsCount$ = this.userEvents$.pipe(map((events) => events.length));
  events$ = this.selectAll().pipe(
    map((events) => events.filter((event) => !event.joined))
  );

  constructor(protected store: EventStore) {
    super(store);
  }
}
